import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { camelizeKeys, decamelizeKeys } from 'humps';

export const decamelizeRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  if (config.params) {
    config.params = decamelizeKeys(config.params);
  }
  if (config.data && !(config.data instanceof FormData)) {
    config.data = decamelizeKeys(config.data);
  }
  return config;
};

export const camelizeResponse = (response: AxiosResponse): AxiosResponse => {
  if (response.data && response.headers['content-type'] === 'application/json') {
    response.data = camelizeKeys(response.data);
  }
  return response;
};
